module.exports = __webpack_public_path__ + "static/media/blog-5.a479cf1c.jpg";